import React from "react";
import { intlFormatDistance, parseISO, differenceInMonths } from "date-fns";
import { usePageMetadata } from "../../../context/PageMetadata";
import styled from "styled-components";
import { z } from "zod";
export const RelativeFormattedDatePropsSchema = z.object({
    date: z.string(),
});
export function isValidDate(date) {
    return date instanceof Date && !isNaN(date.getTime());
}
const _RelativeFormattedDate = ({ date }) => {
    const parsedDate = new Date(date);
    const { locale } = usePageMetadata();
    if (!isValidDate(parsedDate)) {
        console.error("Invalid date provided:", date);
        return null;
    }
    const targetDate = parseISO(date);
    const now = new Date();
    const monthsDiff = Math.abs(differenceInMonths(targetDate, now));
    const shouldForceMonthsUnit = monthsDiff > 2 && monthsDiff <= 12;
    const relativeDate = intlFormatDistance(targetDate, now, {
        locale,
        unit: shouldForceMonthsUnit ? "month" : undefined,
    });
    return React.createElement("time", { dateTime: date }, relativeDate);
};
export const RelativeFormattedDate = styled(_RelativeFormattedDate) ``;
//# sourceMappingURL=RelativeFormattedDate.js.map